import React from "react";
import "../../styles/pages/home/EndPage.scss";
import { Trans, useTranslation } from "react-i18next";
function End() {
  return (
    <div className="end-page-container">
      <div className="end-title">
        <Trans i18nKey="endPage:end_title" />
      </div>
    </div>
  );
}

export default End;
